module.exports = __webpack_public_path__ + "static/media/hotSpot_hover.7654f92c.png";